import { Text } from 'common-components/typography';
import React from 'react';
import { ROSTER_WEEKLY_CONFIG } from '../roster-weekly-config';
import CommonUtils from 'utilities/common-utils';

const { GROUP_ROW_HEIGHT } = ROSTER_WEEKLY_CONFIG;

interface HoursWorkedColumnProps {
  showCost?: boolean;
  hoursTotal: number;
  costTotal: number;
}

export function HoursWorkedColumn({ hoursTotal, costTotal, showCost }: HoursWorkedColumnProps) {
  const height = `${GROUP_ROW_HEIGHT}px`;

  return (
    <div className=' pv-small ph-small flex-column ' style={{ height }}>
      {showCost && (
        <div className='overflow-hidden text-overflow-ellipsis whitespace-nowrap line-height-120'>
          <Text color='secondary' size='small'>
            COST
          </Text>
          <br />
          <Text size='regular'>
            {CommonUtils.formatPrice(costTotal)} • {hoursTotal} hours
          </Text>
        </div>
      )}
    </div>
  );
}
